import React from "react";
import "../../css/components/Hero.css";

const renderLines = (text) => {
  const lines = text.split("\n");

  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};
function Hero({
  title = "",
  subtitle = "",
  backgroundImage = "",
  titleAlign = "center", // "center" | "left"
  subtitleAlign = "center", // "center" | "left"
  children,
}) {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <p style={{ textAlign: subtitleAlign }} className="content">
            {renderLines(subtitle)}
          </p>
          <h1 className="font-hero-title" style={{ textAlign: titleAlign }}>
            {renderLines(title)}
          </h1>
          {title && (<div className={`divider align-${titleAlign}`}></div>)}
          {children}
        </div>
      </div>
    </section>
  );
}

export default Hero;
